export const getHotelSystemsDigitalCheckinConfig = `
  query MyQuery($hotelId : String!) {
    getHotelSystemsDigitalCheckinConfig(input: {hotelId: $hotelId}) {
      hotelId
      personalisation
      checkInAvailability
      accompanyingGuestDetails {
        status
        features {
          name
          required
        }
      }
      covid19Documents {
        status
        features {
          name
          required
        }
      }
      eRegistrationDestination {
        key
        value
      }
      holdAmountConfig {
        currency
        type
        value
        incidentals {
          type
          value
        }
      }
      guestDocumentTypes {
        code
        name
        status
      }
      apiIntegration {
        hotelId
        url
      }
      integrationSource {
        type
        value
      }
      eRegistrationForm {
        guestInformation {
          name
          required
        }
        documentInformation {
          name
          required
        }
        roomDetails {
          name
          required
        }
        travelInfo {
          name
          required
        }
      }
    }
  }
`;

export const getRoomReservationDetails = `
  query MyQuery($hotelId: String!) {
    getRoomReservations(input: {hotelId: $hotelId}) {
      apiIntegrationHotelId
      apiIntegrationURL
      integrationSource
      integrationSourceType
      roomUpgrades
      promoCode
      payment
      payNow
      payAtProperty
      cancelBooking {
        cancelBooking
        expireAt
      }
      modifyBooking {
        cancelBooking
        expireAt
      }
    }
  }
  `;

export const getHotelSystemsModuleSummary = `
  query MyQuery($hotelId: String!) {
    getHotelSystemsModuleConfigurations(input: { hotelId: $hotelId }) {
      isConfirmed
      hotelServiceModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
      entertainmentModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
      guestRoomExpModules {
        module
        enabledDevices {
          mobile
          tablet
          webApp
        }
      }
    }
  }
`;

export const getListTemplates = `
    query MyQuery($hotelId: String!) {
      listTemplates(input: { hotelId: $hotelId }) {
        id
        name
        createdBy
        rangeList {
          rangeFrom
          rangeTo
        }
        statistics {
          areas
          curtains
          scenes
          lights
          rooms
          thermostats
        }
        areas {
          id
          nameAliases {
            alias
            languageId
            value
          }
          curtains {
            name
            id
            nameAliases {
              alias
              languageId
            }
            type
          }
          name
          thermostats {
            name
            id
            nameAliases {
              alias
              languageId
            }
          }
          lights {
            dimmerLevel
            icon
            name
            id
            nameAliases {
              alias
              languageId
            }
            type
          }
          scenes {
            dimmerLevel
            name
            id
            nameAliases {
              languageId
              alias
            }
            type
          }
        }
        doorLock {
          id
          name
          nameAliases {
            languageId
            alias
          }
        }
        doorLockVendor {
          attributes {
            key
            value
          }
          controlSpecificAttributes {
            key
            value
          }
          id
          name
        }
        doorCameraEnabled
        hotelId
        id
        name
        thermostatVendor {
          attributes {
            key
            value
          }
          controlSpecificAttributes {
            key
            value
          }
          id
          name
        }
        lightsVendor {
          id
          name
          attributes {
            key
            value
          }
        }
        curtainsVendor {
          id
          name
          attributes {
            key
            value
          }
        }
        scenesVendor {
          id
          name
          attributes {
            key
            value
          }
        }
      }
    }
  `;

export const GetRoomListByHotelId =
  /* GraphQL */
  `
    query MyQuery($hotelId: String!) {
      GetRoomListByHotelId(input: { hotelId: $hotelId }) {
        hotelId
        roomId
        status
        templateId
      }
    }
  `;

export const GetRoomConfigDetailsByHotelIdAndRoomId = `
    query MyQuery($hotelId: String!, $roomId: Int!) {
      GetRoomConfigDetailsByHotelIdAndRoomId(
        input: { hotelId: $hotelId, roomId: $roomId }
      ) {
        areas {
          curtains {
            id
            name
            nameAliases {
              alias
              languageId
            }
            status
            type
            vendor {
              controlSpecificAttributes {
                key
                value
              }
              attributes {
                key
                value
              }
              id
              name
            }
          }
          id
          lights {
            dimmerLevel
            icon
            id
            name
            nameAliases {
              alias
              languageId
            }
            status
            type
            vendor {
              controlSpecificAttributes {
                key
                value
              }
              attributes {
                key
                value
              }
              id
              name
            }
          }
          name
          scenes {
            dimmerLevel
            id
            name
            nameAliases {
              alias
              languageId
            }
            status
            type
            vendor {
              controlSpecificAttributes {
                key
                value
              }
              attributes {
                key
                value
              }
              id
              name
            }
          }
          thermostats {
            id
            name
            nameAliases {
              alias
              languageId
            }
            status
            vendor {
              controlSpecificAttributes {
                key
                value
              }
              attributes {
                key
                value
              }
              id
              name
            }
          }
        }
        ddk {
          code
          id
          protocol
          provider
        }
        dnd {
          code
          id
          protocol
          provider
        }
        hotelId
        mmr {
          code
          id
          protocol
          provider
        }
        dc {
          ip
          port
        }
        doorLock {
          id
          name
          nameAliases {
            alias
            languageId
          }
          status
          vendor {
            controlSpecificAttributes {
              key
              value
            }
            attributes {
              key
              value
            }
            id
            name
          }
        }
        roomId
        status
        templateId
      }
    }
  `;

export const getSpaList = `
  query MyQuery ($hotelId : String!){
    listSpa(input: {hotelId: $hotelId}) {
      code
      createdAt
      createdBy
      description
      hotelId
      id
      hours {
        allTime
        everyday
        timings {
          day
          from
          to
        }
      }
      name
      pk
      sk
      treatmentsMenu
      updatedAt
      updatedBy
      version
      images {
        fileName
        index
        master
        ratio16to9
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      location {
        addressLine1
        addressLine2
        area
        city
        country
        postalCode
        state
      }
    }
  }`;

export const getSpaReservations = `
query MyQuery ($hotelId : String!){
  getSpaReservationConfigs(input: {hotelId: $hotelId}) {
    hotelId
    multipleHours
    pk
    sk
    spaId
    treatmentList
    pos {
      active
      id
    }
    booking {
      active
      iptv {
        type
        value
      }
      mobile {
        type
        value
      }
    }
  }
}`;

export const getRestaurantDetails = `
query MyQuery ($hotelId : String!){
  getRestaurantDetails(input: {hotelId: $hotelId}) {
    restaurant {
      code
      contact {
        URL
        type
        reviewerTitle
      }
      contactNumber
      createdAt
      createdBy
      cuisine
      description
      email
      hotelId
      id
      hours {
        close
        day
        open
      }
      images {
        fileName
        index
        ratio16to9
        master
        ratio1to1
        ratio21to9
        ratio9to21
        ratio9to16
      }
      menu
      name
      pk
      sk
      type
      updatedAt
      updatedBy
      venueGroupId
      version
    }
  }
}`;

export const getRestaurantConfigs = `
query MyQuery ($hotelId : String!){
  getRestaurantConfig(input: {hotelId: $hotelId}) {    
    posActive
    restaurantId
  }
}`;

export const listTelephonyOptions = `
query MyQuery {
  listTelephonyOptions {
    id
    label
  }
}`;

export const getTelephonyConfig = `
query MyQuery($hotelId: String!) {
  getTelephonyConfig(input: {hotelId: $hotelId}) {
    hotelId
    portTLS
    portTLSSecondary
    sipDomain
    epbx {
      active
      value
    },
    sessionManager {
      active
      value
    }
    sessionManagerSecondary {
      active
      value
    }
    securityModule {
      value
      active
    }
    sbcEmsServer {
      value
      active
    }
    sbcEmsServerSecondary {
      active
      value
    }
    sbcA1 {
      active
      value
    }
  }
}`;

export const getHotelSystemSettings = `
query MyQuery($hotelId: String!) {
   getHotelSystemsSetting(input: {hotelId: $hotelId}) {
    digitalCheckIn
    digitalCheckOut
    hotelId
    inRoomDinning
    housekeeping
    pk
    roomReservations
    sk
    telephony
    tableReservation
    spaReservation
    loyalty
    payment
    weather
    documentScan
    travelService
    chat
    eventHub
    analytics
    thirdPartyNotificationService
    centralReservationSystem
   }
  }
`;

export const getIntegrationConfigs = `
  query MyQuery($configName: String!) {
    getIntegrationConfiguration(input: {configName: $configName}) {
      jsonResponse
    }
  }
  `;

export const getIntegrationStatus = `
  query MyQuery($hotelId: String!) {
    getIntegrationStatusByHotelId(input: {hotelId: $hotelId}) {
      CRS {
        authenticationError
        metaData
        platform
        status
        type
      }
      DDL {
        authenticationError
        metaData
        platform
        status
        type
      }
      GRMS {
        authenticationError
        metaData
        platform
        status
        type
      }
      HK {
        metaData
        authenticationError
        platform
        status
        type
      }
      LOYALTY {
        authenticationError
        metaData
        platform
        status
        type
      }
      PAYMENTS {
        authenticationError
        platform
        metaData
        status
        type
      }
      PMS {
        authenticationError
        metaData
        platform
        status
        type
      }
      POS {
        authenticationError
        metaData
        platform
        status
        type
      }
      RRS {
        authenticationError
        metaData
        platform
        status
        type
      }
      SRS {
        authenticationError
        metaData
        platform
        status
        type
      }
      KYCDOC {
        authenticationError
        metaData
        platform
        status
        type
      }
      EVENTHUB {
        authenticationError
        metaData
        platform
        status
        type
      }
      ANALYTICS {
        authenticationError
        metaData
        platform
        status
        type
      }
      CHAT {
        authenticationError
        metaData
        platform
        status
        type
      }
      TPNS {
        authenticationError
        metaData
        platform
        status
        type
      }
      TS {
        authenticationError
        metaData
        platform
        status
        type
      }
      WEATHER {
        authenticationError
        metaData
        platform
        status
        type
      }
    }
  }
  `;

export const getAppConfigurationsListQuery = `
  query MyQuery($hotelId: String!) {
    listAppConfigurations(input: {hotelId: $hotelId}) {
      id
      type
      configuration
      createdAt
      createdBy
      hotelId
      description
      name
      updatedBy
      updatedAt
      userName
      channelType
      pwaURLCode
      productURLCode
   }
  }
`;
